import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FreightHoverIcon, FreightIcon, GisHoverIcon, GisIcon, HealthCareIcon, HealthHoverIcon, IotHoverIcon, IotIcon } from '../../../resources/svg';

const DomainExpertiseComponent = () => {

    const [isIoT, setIsIot] = useState(false);
    const [isGis, setIsGis] = useState(false);
    const [isHealth, setIsHealth] = useState(false);
    const [isFreight, setIsFreight] = useState(false);

    const getIotIcon = () => {
        return isIoT ? (<IotHoverIcon />) : (<IotIcon />);
    }

    const getFreightIcon = () => {
        return isFreight ? (<FreightHoverIcon />) : (<FreightIcon />);
    }

    const getGisIcon = () => {
        return isGis ? (<GisHoverIcon />) : (<GisIcon />);
    }

    const getHealthIcon = () => {
        return isHealth ? (<HealthHoverIcon />) : (<HealthCareIcon />)
    };
    
        return (
            <section id="domains" className="team section light-background">

                <div className="container section-title" data-aos="fade-up">
                    <h2>Why Us</h2>
                    <p>Exceptional Digital Transformation Services in Multiple Industry Domains</p>
                </div>

                <div className="container">

                    <div className="row gy-4">

                        <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100">
                            <Link to="/expertise/iot">
                                <div className="team-member" onMouseEnter={() => setIsIot(true)}
                onMouseLeave={() => setIsIot(false)}>
                                    <div className="member-img">
                                        {getIotIcon()}
                                        {/* <img src="assets/img/expertise/PNG/iot_1PNG.png" className="img-fluid" alt="" /> */}
                                        {/* <div className="social">
                                            <a href=""><i className="bi bi-twitter-x"></i></a>
                                            <a href=""><i className="bi bi-facebook"></i></a>
                                            <a href=""><i className="bi bi-instagram"></i></a>
                                            <a href=""><i className="bi bi-linkedin"></i></a>
                                        </div> */}
                                    </div>
                                    <div className="member-info">
                                        <h4>Internet of Things (IoT)</h4>
                                        <span>Harnessing IoT and Sensor Data for Strategic Growth</span>
                                    </div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100">
                            <Link to="/expertise/freight">
                                <div className="team-member" onMouseEnter={() => setIsFreight(true)}
                onMouseLeave={() => setIsFreight(false)}>
                                    <div className="member-img">
                                        {getFreightIcon()}
                                        {/* <img src="assets/img/expertise/PNG/freight_1PNG.png" className="img-fluid" alt="" /> */}
                                        {/* <div className="social">
                                        <a href=""><i className="bi bi-twitter-x"></i></a>
                                        <a href=""><i className="bi bi-facebook"></i></a>
                                        <a href=""><i className="bi bi-instagram"></i></a>
                                        <a href=""><i className="bi bi-linkedin"></i></a>
                                    </div> */}
                                    </div>
                                    <div className="member-info">
                                        <h4>Freight Management</h4>
                                        <span>Optimizing Freight Management for Maximum Efficiency</span>
                                    </div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100">
                            <Link to="/expertise/gis">
                                <div className="team-member" onMouseEnter={() => setIsGis(true)}
                onMouseLeave={() => setIsGis(false)}>
                                    <div className="member-img">
                                        {getGisIcon()}
                                        {/* <img src="assets/img/expertise/PNG/gis_1PNG.png" className="img-fluid" alt="" /> */}
                                        {/* <div className="social">
                                        <a href=""><i className="bi bi-twitter-x"></i></a>
                                        <a href=""><i className="bi bi-facebook"></i></a>
                                        <a href=""><i className="bi bi-instagram"></i></a>
                                        <a href=""><i className="bi bi-linkedin"></i></a>
                                    </div> */}
                                    </div>
                                    <div className="member-info">
                                        <h4>GIS Mapping</h4>
                                        <span>Unlocking Insights with Geographic Intelligence</span>
                                    </div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100">
                            <Link to="/expertise/healthcare">
                                <div className="team-member" onMouseEnter={() => setIsHealth(true)}
                onMouseLeave={() => setIsHealth(false)}>
                                    <div className="member-img">
                                        {getHealthIcon()}
                                        {/* <img src="assets/img/expertise/PNG/health_2PNG.png" className="img-fluid" alt="" /> */}
                                        {/* <div className="social">
                                        <a href=""><i className="bi bi-twitter-x"></i></a>
                                        <a href=""><i className="bi bi-facebook"></i></a>
                                        <a href=""><i className="bi bi-instagram"></i></a>
                                        <a href=""><i className="bi bi-linkedin"></i></a>
                                    </div> */}
                                    </div>
                                    <div className="member-info">
                                        <h4>Healthcare</h4>
                                        <span>Revolutionizing Healthcare with Innovative Clinical Solutions</span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        )
}

export default DomainExpertiseComponent;